import customAxios from "../../customAxios";
import { GET_USER_INFO } from "../../routes";

const getUserInfo = async () => {
  try {
    return (await customAxios.get(GET_USER_INFO)).data;
  } catch (error: any) {
    console.log({ GET_USER_INFO: error });
  }
};

export default getUserInfo;
